












import {
  computed,
  defineComponent,
  Ref,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import CInfoModal from '~/components/shared/configurable/info/CInfoModal.vue'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  components: { CInfoModal },
  props: formFieldProps,
  setup(props) {
    const { name, humanName } = toRefs(props)

    const checked = ref(false)
    const { t } = useI18n()

    function onValue(v: Ref<any>) {
      if (v.value) {
        checked.value = v.value
      }
    }

    const checkboxLabel = computed(() => {
      switch (name.value) {
        case 'exact_location':
          return 'Εμφάνιση ακριβής τοποθεσίας στους επισκέπτες του site'
        case 'offers_enabled':
          return t('offers accepted')
        default:
          return humanName.value
      }
    })

    const { valueChanged } = useClassifiedForm(props, { onValue })

    function handleCheckboxChange(checkboxEnabled: boolean) {
      valueChanged(name.value, checkboxEnabled)
    }

    return {
      checked,
      handleCheckboxChange,
      checkboxLabel
    }
  }
})
